import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

const instructions = [
  'All the students appearing for the test are evaluated on their previous year\'s curriculum. Questions will be based on analytical thinking and reasoning skills.',
  'Duration for entrance test of each subject is 45 minutes.',
];

const entranceRows = [
  {
    admission: 'Class 1',
    subjects: 'English and Mathematics',
  },
  {
    admission: 'Class 2 - 5',
    subjects: 'English, Mathematics and Hindi / Kannada',
  },
  {
    admission: 'Class 6 - 8',
    subjects: 'English, Mathematics, Science and Hindi / Kannada',
  },
  {
    admission: 'Class 9',
    subjects: 'English, Mathematics, Science and Hindi / Sanskrit / Kannada',
  },
  {
    admission: 'Class 11',
    subjects: (
      <Box>
        <Typography variant="body2" sx={{ fontFamily: 'inherit', fontSize: 'inherit' }}>
          For <strong>Science Stream</strong> - English, Physics, Chemistry and Mathematics
        </Typography>
        <Typography
          variant="body2"
          sx={{ fontFamily: 'inherit', fontSize: 'inherit', marginTop: 1.5 }}
        >
          For <strong>Commerce Stream</strong> - English and Basic Mathematics
        </Typography>
        <Typography
          variant="body2"
          sx={{ fontFamily: 'inherit', fontSize: 'inherit', marginTop: 1.5 }}
        >
          For <strong>Humanities Stream</strong> - English and Basic Mathematics
        </Typography>
      </Box>
    ),
  },
];

const notes = [
  'Entrance test schedules for Classes 1 to 9 and 11, along with all relevant details, will be communicated to applicants via email.',
  'Upon meeting the required criteria in the Entrance Test, the student and both parents will be invited for an interaction with the Principal.',
  'The original Birth Certificate, Aadhaar Cards and the Final Marks Card of previous three years have to be carried for verification during the interaction (MANDATORY).',
];

const Main = () => {
  return (
    <Box
      sx={{
        color: '#000',
        fontFamily: '"Times New Roman", Times, serif',
        paddingTop: { xs: 2, md: 1 },
        paddingBottom: 5,
      }}
    >
      <Typography
        component="h1"
        sx={{
          fontFamily: 'inherit',
          fontSize: { xs: 22, md: 28 },
          fontWeight: 400,
          lineHeight: 1.2,
          marginBottom: 4,
        }}
      >
        ADMISSIONS - Entrance Test Details and General Instructions
      </Typography>

      <Box component="ul" sx={{ margin: 0, paddingLeft: 2.5 }}>
        {instructions.map((instruction) => (
          <Typography
            component="li"
            key={instruction}
            sx={{
              fontFamily: 'inherit',
              fontSize: { xs: 14, md: 16 },
              lineHeight: 1.2,
              marginBottom: 1.5,
              paddingLeft: 2,
            }}
          >
            {instruction}
          </Typography>
        ))}
      </Box>

      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          border: '1px solid #d7e0e8',
          borderRadius: 0,
          boxShadow: 'none',
          marginLeft: { xs: 0, md: 2 },
          marginTop: 1,
          maxWidth: 720,
          overflowX: 'auto',
        }}
      >
        <Table
          aria-label="entrance test subjects"
          sx={{
            '& .MuiTableCell-root': {
              borderColor: '#e0e0e0',
              color: '#000',
              fontFamily: '"Times New Roman", Times, serif',
              fontSize: { xs: 13, md: 15 },
              lineHeight: 1.25,
              padding: '9px 12px',
            },
          }}
        >
          <TableHead>
            <TableRow sx={{ backgroundColor: '#eaf5ff' }}>
              <TableCell sx={{ fontWeight: 700, width: '27%' }}>
                Admission sought for
              </TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Subjects for Entrance Test</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {entranceRows.map((row) => (
              <TableRow key={row.admission}>
                <TableCell sx={{ verticalAlign: 'top' }}>{row.admission}</TableCell>
                <TableCell>{row.subjects}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box
        sx={{
          backgroundColor: '#f5f5f5',
          marginTop: 2,
          padding: { xs: 2, md: '4px 0 14px' },
        }}
      >
        <Typography
          component="h2"
          sx={{
            color: '#495078',
            fontFamily: 'inherit',
            fontSize: { xs: 18, md: 22 },
            fontWeight: 400,
            margin: { xs: 0, md: '0 0 14px 18px' },
          }}
        >
          NOTE :
        </Typography>

        <Box component="ul" sx={{ margin: 0, paddingLeft: { xs: 2.5, md: 2 } }}>
          {notes.map((note) => (
            <Typography
              component="li"
              key={note}
              sx={{
                fontFamily: 'inherit',
                fontSize: { xs: 14, md: 16 },
                fontWeight: 700,
                lineHeight: 1.15,
                marginBottom: 2,
                paddingLeft: 2,
              }}
            >
              {note}
            </Typography>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Main;
